import { Skeleton } from "../skeleton/index";
import "./tableLoader.css";

export const TableLoader = () => {
  return (
    <table className="response-table">
      <thead>
        <tr>
          <th>
            <Skeleton
              style={{ height: "12px", borderRadius: "10px", width: "200px", margin: "13px 0" }}
            />
          </th>
          <th>
            <Skeleton
              style={{ height: "12px", borderRadius: "10px", width: "100px", margin: "13px 0" }}
            />
          </th>
          <th>
            <Skeleton
              style={{ height: "12px", borderRadius: "10px", width: "100px", margin: "13px 0" }}
            />
          </th>
          <th>
            <Skeleton
              style={{ height: "12px", borderRadius: "10px", width: "100px", margin: "13px 0" }}
            />
          </th>
          <th>
            <Skeleton
              style={{ height: "12px", borderRadius: "10px", width: "100px", margin: "13px 0" }}
            />
          </th>
        </tr>
      </thead>
      <tbody>
        {[...Array(10)]?.map((_, index) => {
          return (
            <tr key={index}>
              <td>
                <Skeleton
                  style={{ height: "12px", borderRadius: "10px", width: "200px", margin: "13px 0" }}
                />
              </td>
              <td>
                <Skeleton
                  style={{ height: "12px", borderRadius: "10px", width: "100px", margin: "13px 0" }}
                />
              </td>
              <td>
                <Skeleton
                  style={{ height: "12px", borderRadius: "10px", width: "100px", margin: "13px 0" }}
                />
              </td>
              <td>
                <Skeleton
                  style={{ height: "12px", borderRadius: "10px", width: "100px", margin: "13px 0" }}
                />
              </td>
              <td>
                <Skeleton
                  style={{ height: "12px", borderRadius: "10px", width: "100px", margin: "13px 0" }}
                />
              </td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );
};
